// extracted by mini-css-extract-plugin
export default {"pageWrapper":"styles_pageWrapper__5xJeY","pendingWrapper":"styles_pendingWrapper__1tQLE"};